import { appendAttributionToPath, GuestIntakeAttribution } from './guestIntake';

export const BOOK_MEETING_INTENT = 'book_meeting';

export function isBookMeetingIntent(intent: string | null | undefined): boolean {
  return intent === BOOK_MEETING_INTENT;
}

export function loginPathWithBookMeetingIntent(attribution?: GuestIntakeAttribution): string {
  const base = `/login?intent=${BOOK_MEETING_INTENT}`;
  return attribution ? appendAttributionToPath(base, attribution) : base;
}

export function registerPathWithBookMeetingIntent(attribution?: GuestIntakeAttribution): string {
  const base = `/register?intent=${BOOK_MEETING_INTENT}`;
  return attribution ? appendAttributionToPath(base, attribution) : base;
}
